import React, { useContext, useEffect, useState } from 'react';
import { ConfigProvider } from 'antd';
import { THEME_MODE_LIST, getSeathruTheme } from '@configs/themeConfig';
import { setCssVariables } from '@src/theme/index';
import { useMediaMatch } from 'rooks';

const LOCAL_STORAGE_THEME_MODE_KEY = 'seathru-theme-mode';
const defaultMode = localStorage.getItem(LOCAL_STORAGE_THEME_MODE_KEY) || THEME_MODE_LIST.default;

const ThemeContext = React.createContext({
  themeMode: defaultMode,
  setThemeMode: () => {},
});

export default function SeathruThemeProvider({ children }) {
  const isOsDarkMode = useMediaMatch('(prefers-color-scheme: dark)');
  const [themeMode, setThemeMode] = useState(defaultMode);

  const setSeathruTheme = (themeMode) => {
    const { theme, antdThemeConfig } = getSeathruTheme(themeMode);

    ConfigProvider.config(antdThemeConfig);
    setCssVariables(theme);
    localStorage.setItem(LOCAL_STORAGE_THEME_MODE_KEY, themeMode);
  };

  useEffect(() => {
    setSeathruTheme(themeMode);
  }, [themeMode, isOsDarkMode]);

  const contextValue = {
    themeMode,
    setThemeMode,
  };
  return (
    <ThemeContext.Provider value={contextValue}>
      <ConfigProvider>
        {children}
      </ConfigProvider>
    </ThemeContext.Provider>
  );
}

export const useThemeMode = () => {
  const { themeMode, setThemeMode } = useContext(ThemeContext);

  try {
    if (!setThemeMode) {
      throw new Error('Error: ‘setThemeMode’ is not defined');
    }
  } catch (err) {
    console.log(err);
  }

  return { themeMode, setThemeMode };
};
